// extracted by mini-css-extract-plugin
export default {"container":"text-input-area_container__DIy59","border":"text-input-area_border__n6kkI","input":"text-input-area_input__5piJF","button":"text-input-area_button__Av2H2"};